import { useContext, useEffect, useState } from 'react';
import AuthContext from '../../context/autenticacion/authContext.js';
import { useT } from 'i18n';
import logoPanther from '../../assets/scss/black-dashboard-react/panther/pantherlogo_name.png';

// Pantalla de carga: va diciendo qué está pasando y, si tarda demasiado, ofrece reintentar.
const Loading = () => {
  const { t } = useT();
  const { panther_load, recargandoapp } = useContext(AuthContext);
  const [seg, setSeg] = useState(0);

  useEffect(() => { window.scrollTo(0, 0); }, [panther_load]);

  useEffect(() => {
    if (panther_load !== true) { setSeg(0); return undefined; }
    const id = setInterval(() => setSeg((s) => s + 1), 1000);
    return () => clearInterval(id);
  }, [panther_load]);

  if (panther_load !== true) return null;

  const paso = seg < 3 ? 'carga.paso1' : seg < 8 ? 'carga.paso2' : 'carga.paso3';
  const lento = seg >= 15;

  return (
    <div className={`loading ${recargandoapp === true ? 'loading-fx-null' : ''}`} role="status" aria-live="polite">
      <div className="elemento1">
        <img alt="Panther7" src={logoPanther} />
        <img className="img-flat" alt="" src={logoPanther} />
      </div>
      <div className="elemento2">
        <div className="bar" />
        <p>{t(lento ? 'carga.lento' : paso)}</p>
        {lento && (
          <button type="button" className="p7-carga-reintentar" onClick={() => window.location.reload()}>
            {t('carga.reintentar')}
          </button>
        )}
      </div>
    </div>
  );
};

export default Loading;
